import { ProductPlanDomain, ProductPlanResponse, RubberPlanResponse } from '@/shared/state/api/swagger';

const stringToNumber = (value: string | number | undefined): number => {
	if (value) {
		const prepareValue = String(value)
			.replace(/[^0-9,.хx]/g, '')
			.replace(/,/g, '.')
			.toLowerCase()
			.replace(/х/g, 'x');
		return prepareValue.split('x').reduce((a, c) => a * Number(c), 1) || 0;
	}
	return 0;
};

type ReleaseDomain = {
	count?: string;
	count_kg?: string;
	number?: string;
	fio?: string;
	id?: number;
	[key: string]: any;
};

export const calculateSummary = ({
	product_releases,
	rubber_releases,
	return_count,
}: {
	product_releases?: ProductPlanDomain['product_releases'];
	rubber_releases?: RubberPlanResponse['rubber_plan_releases'];
	return_count: number | string | undefined;
}) => {
	const releases = (product_releases || rubber_releases) as ReleaseDomain[] | undefined;

	const releases_sum = releases?.reduce((acc, curr) => acc + Number(stringToNumber(curr.count)), 0) ?? 0;
	const return_sum = Number(stringToNumber(return_count));

	if (releases_sum === 0 && !return_count) {
		return '';
	}

	const prepareResult = (releases_sum - return_sum).toFixed(1);
	return String(prepareResult).replace(/\./g, ',');
};

export const calculateProductSummary = (productPlan: ProductPlanResponse, returnCount: number | string | undefined) => {
	return calculateSummary({
		product_releases: productPlan.product_releases,
		return_count: returnCount,
	});
};

export const calculateRubberSummary = (rubberPlan: RubberPlanResponse, returnCount: number | string | undefined) => {
	return calculateSummary({
		rubber_releases: rubberPlan.rubber_plan_releases,
		return_count: returnCount,
	});
};
